import React, { useState } from "react";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import RiteDepartmentForm from "./RiteDepartmentForm";
import { Button, Box } from "@mui/material";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

const RiteDepartmentDetails = ({ department, onRefresh }) => {

  const [data,setData] = useState(department);
      const token = getDecryptedAccessToken();

  const handleUpdate = async (values) => {

    const res = await ApiServices.put(
      `/api/v1/admin/departments/${department.id}/`,
      values,
      { Authorization: `Bearer ${token}` }
    );

    setData(res.data);
    onRefresh();
  };

  const handleDelete = async () => {

    if(!window.confirm("Delete this department?")) return;

    await ApiServices.delete(
      `/api/v1/admin/departments/${department.id}/`
    );

    onRefresh();
  };

  return (
    <Box>

      <RiteDepartmentForm
        title="Department Details"
        defaultValues={data}
        onSubmit={handleUpdate}
      />

      <Button
        color="error"
        onClick={handleDelete}
      >
        Delete Department
      </Button>

    </Box>
  );
};

export default RiteDepartmentDetails;